var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper scroll-y custom-scrollbar with-tabs view-foodpairing",attrs:{"id":"infinite-list"}},[_c('page-title',{attrs:{"title":'Foodpairing',"back":true}}),_c('iframe',{attrs:{"id":"ksiazece","src":_vm.iframe.url,"width":"100%","height":"100%","frameborder":"0","marginheight":"0","marginwidth":"0","scrolling":"no"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }